import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { type LaunchDarklyFlags, withLaunchDarkly } from '@/common/launchDarkly';
import SavingOverlay from '../components/senderBuild/SavingOverlay';
import { useDS3Access } from '../hooks/trial/use-ds3-access';
import { errorToast } from '../store/pageFrame/actions';

/**
 * Accepts a coupon URL for a Stripe discount page and redirects the user to that page if they do not have an active subscription.
 */
function CouponRedirect(props: { flags?: LaunchDarklyFlags }) {
  const dispatch = useDispatch();
  const { isLoading, hasDs3Access } = useDS3Access(props.flags);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const url = queryParams.get('url');

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(errorToast('Something went wrong. Please try again.'));
      window.location.assign('/envelopes');
    }, 5000);

    if (url && !isLoading) {
      clearTimeout(timeoutId); // Clear the timeout if redirecting

      if (hasDs3Access) {
        // User already has a valid subscription, should not see subscription page
        dispatch(errorToast('This account already has a valid subscription and cannot apply this coupon.'));
        window.location.assign('/envelopes');
      } else {
        // Send them to coupon page
        window.location.assign(url);
      }
    }

    return () => clearTimeout(timeoutId);
  }, [location.search, url, hasDs3Access, isLoading, dispatch]);

  return <SavingOverlay />;
}

const withLd = withLaunchDarkly(CouponRedirect);
export { withLd as CouponRedirect };
